import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Noticias from '../views/Noticias.vue'
import Noticia from '../views/Noticia.vue'
import Roteiros from '../views/Roteiros.vue'
import Roteiro from '../views/Roteiro.vue'
import Bloco from '../views/Bloco.vue'
import Eventos from '../views/Eventos.vue'
import Evento from '../views/Evento.vue'
import Contactos from '../views/Contactos.vue'
import Admin from '../views/Admin.vue'
import VueSimpleMarkdown from 'vue-simple-markdown'
import SocialSharing from 'vue-social-sharing'
import 'vue-simple-markdown/dist/vue-simple-markdown.css'
import VueRecaptcha from "vue-recaptcha";
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDaxN7CkrlhiiZQV9NNJS7vhXXUU_19PU8',
  },
  installComponents: true
})
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.use(VueSimpleMarkdown)
Vue.use(VueRecaptcha)
Vue.use(SocialSharing)
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: '/',
    component: Home
  },
  {
    path: '/:lang?/noticias',
    name: '/noticias',
    component: Noticias
  },
  {
    path: '/:lang?/noticia/:id',
    name: '/noticia',
    component: Noticia
  },
  {
    path: '/:lang?/roteiros',
    name: '/roteiros',
    component: Roteiros
  },
  {
    path: '/:lang?/roteiro/:id',
    name: '/roteiro',
    component: Roteiro
  },
  {
    path: '/:lang?/roteiro/:id/bloco/:idBloco',
    name: '/bloco',
    component: Bloco
  },
  {
    path: '/:lang?/eventos',
    name: '/eventos',
    component: Eventos
  },
  {
    path: '/:lang?/evento/:id',
    name: '/evento',
    component: Evento
  },
  {
    path: '/:lang?/contactos',
    name: '/contactos',
    component: Contactos
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})


export default router
